export default "__VITE_ASSET__eac0a5ea__"